<template>
  <div>
    <v-row>
      <v-col cols="12" v-if="$vuetify.breakpoint.mdAndUp">
        <v-card elevation="0" color="transparent" class="rounded-lg mt-5 primary--text">
          <v-row class="text-start">
            <v-col cols="4">
              <span class="ms-3">{{ $t("course.course") }}</span>
            </v-col>

            <v-col cols="2">
              <span>{{ $t("course.createdBy") }}</span>
            </v-col>

            <v-col cols="2">
              <span>{{ $t("course.category") }}</span>
            </v-col>

            <v-col cols="2">
              <span>{{ $t("course.subCategory") }}</span>
            </v-col>

            <v-col cols="2">
              <span>{{ $t("course.courseRate") }}</span>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-row v-if="loading">
          <v-col cols="12" class="my-16">
            <v-progress-circular indeterminate color="primary">
            </v-progress-circular>
          </v-col>
        </v-row>

        <v-row v-else-if="data.length">
          <v-col cols="12" v-for="(course, index) in data" :key="index">
            <available-course-card
              :course="course"
              @statisticsCardReRender="$emit('cardReRender')"
              @coursesListReRender="$emit('coursesReRender')"
            />
          </v-col>
        </v-row>

        <v-row
          v-else
          class="textLight--text font-weight-medium"
          align="center"
        >
          <v-col cols="12">
            {{ $t("noItems") }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AvailableCourseCard from "./AvailableCourseCard.vue";

export default {
  components: {
    AvailableCourseCard,
  },
  props: {
    data: {
      type: Array,
    },
    loading: {
      default: false,
      type: Boolean,
    },
  },
};
</script>
